import { GetUpgradeProrationFnReq, GetUpgradeProrationFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';

export type GetUpgradeProrationResult = GetUpgradeProrationFnRes;

export class GetUpgradeProrationInteractor {
  private readonly getUpgradeProrationFn = httpsCallable<
    GetUpgradeProrationFnReq,
    GetUpgradeProrationFnRes
  >(this.functions, 'getUpgradeProration');

  constructor(private readonly functions: Functions) {}

  public async execute(priceId: string): Promise<GetUpgradeProrationResult> {
    const res = await this.getUpgradeProrationFn({ priceId });
    return res.data;
  }
}
